import React from 'react';
import { X } from 'lucide-react';

interface FilterBarResetButtonProps {
  onReset: () => void;
}

export const FilterBarResetButton: React.FC<FilterBarResetButtonProps> = ({ onReset }) => {
  return (
    <button 
      onClick={onReset}
      className="ml-auto flex items-center gap-1.5 px-3 py-1.5 bg-indigo-50 dark:bg-indigo-900/40 hover:bg-indigo-100 dark:hover:bg-indigo-900/60 text-indigo-600 dark:text-indigo-400 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 border border-indigo-200 dark:border-indigo-800 shadow-sm animate-in fade-in zoom-in duration-300"
    >
      <X size={14} className="animate-spin-slow" />
      Zurücksetzen
    </button>
  );
};
